angular.module('aprima-core-ui').directive('apFormFocus', function () {
    'use strict';

    return {
        restrict: 'A',
        link: function (scope, elem) {
            var handler = function () {
                elem.find('.ng-invalid:first').focus();
            };

            // set up event handler on the form element
            elem.on('submit', handler);

            scope.$on('$destroy', function(){
                elem.off('submit', handler);
            });
        }
    };
});
